// src/api.js
import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Optional: Add token dynamically before each request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response &&
      (error.response.status === 401 || error.response.status === 403)
    ) {
      // remove token
      localStorage.removeItem("token");

      // redirect to login
      window.location.href = "/login";
      // 🔹 we use window.location.href instead of useNavigate (not available here)
    }
    return Promise.reject(error); // let the calling code handle other errors
  }
);

export default api;
